// 定义音程关系
const PITCH_STEP_RELATIONS = {
    '133': 0.5,
    '13': 1,
    '12': 1.5,
    '108': 2,
    '10': 2.5,
    '9': 3.5,
    '85': 4,
    '79': 4.5,
    '76': 5,
    '73': 5.5,
    '7': 6,
    '67': 6.5,
    '64': 7,
    '62': 7.5,
    '6': 8,
    '56': 8.5,
    '5': 9.5,
    '48': 10,
    '46': 10.5,
    '44': 11,
    '42': 11.5,
    '4': 12,
    '38': 12.5,
    '34': 13,
    '32': 13.5,
    '3': 14,
    '26': 14.5,
    '2': 15.5,
    '18': 16,
    '16': 16.5,
    '14': 17,
    '12': 17.5,
    '1': 18
};


const baseNotes = [
    { basePitch: 5, octave: -2 },
    { basePitch: 6, octave: -2 },
    { basePitch: 1, octave: -1 },
    { basePitch: 2, octave: -1 },
    { basePitch: 3, octave: -1 },
    { basePitch: 5, octave: -1 },
    { basePitch: 6, octave: -1 }
];

// 音阶关系（全音数和半音）
const PITCH_STEP_VALUES = {
    1: 0.5,
    2: 1.5,
    3: 2.5,
    4: 3,
    5: 4,
    6: 5,
    7: 6
};

function calculateStepDifference(baseNote, note) {
    const pitchStepDiff = PITCH_STEP_VALUES[note.basePitch] - PITCH_STEP_VALUES[baseNote.basePitch];
    const octaveDiff = 6 * (note.octave - baseNote.octave);
    // 总音高差
    return pitchStepDiff + octaveDiff;
}

let previousNote = null;
let previousPosition = null;  // 上一个音的位置
let consecutiveSameStringCount = 0; // 连续在同一根弦上的音

function selectOptimalPosition(matchedPositions, previousPosition = null) {
    // 提取整数徽
    const extractIntegerHui = (hui) => {
        return hui ? parseInt(hui.replace(/\D/g, '')) : null;
    };

    // 优先级1：排除基准音
    const baseNotePositions = matchedPositions.map((hui, index) => 
        hui !== '' 
            ? { string: ['一','二','三','四','五','六','七'][index], hui } 
            : null
    ).filter(pos => pos !== null);

    // 优先级2：1-13之间的整数徽位
    const integerHuiPositions = baseNotePositions.filter(pos => {
        const intHui = parseInt(pos.hui);
        console.log(intHui)
        return !isNaN(intHui) && intHui >= 1 && intHui <= 13;
    });

    console.log("integerHuiPositions", integerHuiPositions)

    if (integerHuiPositions.length > 0) {
        return integerHuiPositions[0];
    }

    // 优先级3：中间徽位（5-10，忽略最后一位）
    const middleHuiPositions = baseNotePositions.filter(pos => {
        const intHui = extractIntegerHui(pos.hui);
        return intHui !== null && intHui >= 5 && intHui <= 10;
    });

    if (middleHuiPositions.length > 0) {
        return middleHuiPositions[0];
    }

    // 优先级4：如果有前一个音，找最近的徽位
    if (previousPosition) {
        const prevIntHui = extractIntegerHui(previousPosition.hui);
        
        const closestPositions = baseNotePositions.sort((a, b) => {
            const aIntHui = extractIntegerHui(a.hui);
            const bIntHui = extractIntegerHui(b.hui);
            
            return Math.abs(aIntHui - prevIntHui) - Math.abs(bIntHui - prevIntHui);
        });

        if (closestPositions.length > 0) {
            return closestPositions[0];
        }
    }

    // 如果以上都不满足，返回第一个非空位置
    const nonEmptyPositions = baseNotePositions;
    
    return nonEmptyPositions.length > 0 ? nonEmptyPositions[0] : null;
}

function selectPositionWithContext(currentNote, matchedPositions) {

    // 如果已经连续4个音在同一根弦上，强制换弦
    if (consecutiveSameStringCount >= 4) {
        // 重置计数器
        consecutiveSameStringCount = 0;
        
        // 找所有可用的位置
        const differentStringPositions = matchedPositions.map((hui, index) => 
            hui !== '' && (!previousPosition || ['一','二','三','四','五','六','七'][index] !== previousPosition.string)
                ? { 
                    string: ['一','二','三','四','五','六','七'][index], 
                    hui: hui, 
                    originalIndex: index 
                } 
                : null
        ).filter(pos => pos !== null);

        if (differentStringPositions.length > 0) {
            // 使用原有的 selectOptimalPosition 选择最优位置
            const selectedPositionHui = selectOptimalPosition(
                differentStringPositions.map(pos => pos.hui), 
                previousPosition
            );

            // 找到对应的完整位置信息
            const selectedPosition = differentStringPositions.find(
                pos => pos.hui === selectedPositionHui.hui
            );

            if (selectedPosition) {
                previousNote = currentNote;
                previousPosition = selectedPosition;
                consecutiveSameStringCount = 1;
                return selectedPosition;
            }
        }
    }

    // console.log(currentNote, previousNote)
    // 特殊情况：如果前一个音和当前音的音程关系不超过2个全音，优先选取同一根弦
    if (previousPosition && previousNote && 
        Math.abs(calculateStepDifference(previousNote, currentNote)) < 2) {
        const sameStringPosition = matchedPositions.map((hui, index) => 
            hui !== '' && ['一','二','三','四','五','六','七'][index] === previousPosition.string 
                ? { string: ['一','二','三','四','五','六','七'][index], hui } 
                : null
        ).filter(pos => pos !== null);

        // console.log("sameStringPosition", sameStringPosition)

        if (sameStringPosition.length > 0) {
            // 更新前一个音和位置
            previousNote = currentNote;
            previousPosition = sameStringPosition[0];
            consecutiveSameStringCount++;
            return sameStringPosition[0];
        }
    }

    // 正常选择
    const selectedPosition = selectOptimalPosition(matchedPositions, previousPosition);
    
    // 更新前一个音和位置
    previousNote = currentNote;
    previousPosition = selectedPosition;

    // 重置或增加同弦计数
    if (selectedPosition && previousPosition && 
        selectedPosition.string === previousPosition.string) {
        consecutiveSameStringCount++;
    } else {
        consecutiveSameStringCount = 1;
    }
    
    return selectedPosition;
}

export function findPitchPositions(note) {

    // console.log("findPitchPositions", previousPosition)
    const positions = ['', '', '', '', '', '', ''];

    baseNotes.forEach((baseNote, stringIndex) => {
        // 计算输入音符和当前基准音之间的全音数
        const stepDiff = calculateStepDifference(baseNote, note);

        // 找到最接近全音数的徽位
        let closestHui = '';
        let minDiff = Infinity;

        for (const [hui, stepValue] of Object.entries(PITCH_STEP_RELATIONS)) {
            const diff = Math.abs(stepValue - stepDiff);
            if (diff < minDiff) {
                minDiff = diff;
                closestHui = hui;
            }
        }

        // 如果差异很小，认为找到了对应的徽位
        if (minDiff < 0.5) {
            positions[stringIndex] = closestHui;
        }
    });

    console.log("selectedpositions", positions)
    return selectPositionWithContext(note, positions);
}

const note = {
    basePitch: 2,  // re
    octave: 1
};
// 测试
// console.log('findPitchPositions(2)', findPitchPositions(note));  // re